module.exports = __webpack_public_path__ + "static/media/thumb-faveats.8872c7a7.png";